import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {CookieService} from 'ngx-cookie-service';
import {routePath} from 'sdv-common';
import {ApiService} from '../service/api.service';
import {keys, redirect, reload} from '../shared/constants';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  error = '';
  loading = false;
  submitted = false;
  formGroup: UntypedFormGroup;
  verifyFormGroup: UntypedFormGroup;
  contact: string;

  constructor(private apiService: ApiService,
              private formBuilder: UntypedFormBuilder,
              private cookieService: CookieService) {
    if (this.apiService.isAuthorized()) {
      redirect(routePath.root);
    }
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      contact: ['', Validators.required]
    });
    this.verifyFormGroup = this.formBuilder.group({
      code: ['', Validators.required]
    });
    let waitConfirmation = JSON.parse(this.cookieService.get(keys.confirmation) || '{}');
    if (waitConfirmation.id && waitConfirmation.contact) {
      this.contact = waitConfirmation.contact;
    }
  }

  get fg() {
    return this.formGroup.controls;
  }

  get vfg() {
    return this.verifyFormGroup.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    this.loading = true;
    this.fg.contact.disable();

    let _this = this;
    this.apiService.post(
      'users',
      {
        contact: this.fg.contact.value
      })
      .subscribe(response => {
        _this.cookieService.set(
          keys.confirmation,
          JSON.stringify({
            contact: _this.fg.contact.value,
            id: response.id
          }),
          new Date(new Date().getTime() + (15 * 60 * 1000))
        );
        reload(routePath.registration);
      }, err => {
        _this.fg.contact.enable();
        _this.error = err.error.error.message;
        _this.loading = false;
      });
  }

  onVerifySubmit() {
    this.submitted = true;
    if (this.verifyFormGroup.invalid) {
      return;
    }
    this.loading = true;
    this.vfg.code.disable();

    let _this = this;
    this.apiService.patch(
      'contacts',
      {
        hash: btoa(unescape(encodeURIComponent(JSON.parse(this.cookieService.get(keys.confirmation) || '{}').id + ':' + this.vfg.code.value)))
      })
      .subscribe(response => {
        _this.cookieService.delete(keys.confirmation);

        const expires = new Date();
        expires.setDate(expires.getDate() + 1);
        _this.cookieService.set(keys.sid, response.value, expires);

        reload(routePath.home);
      }, err => {
        _this.vfg.code.enable();
        _this.error = err.error.message;
        _this.loading = false;
      });
  }

  changeContact() {
    this.loading = false;
    this.submitted = false;
    this.cookieService.delete(keys.confirmation);
    this.fg.contact.setValue(this.contact);
    this.fg.contact.enable();
    this.contact = null;
  }
}
